import { Textbox } from '@policygenius/mortar';
import React, { useContext } from 'react';

import QuestionBox from 'components/QuestionBox';
import ScreenSizeContext from 'contexts/ScreenSize';
import { FieldRenderProps } from 'forms/types';
import getErrorMessage from 'forms/utils/getErrorMessage';

import styles from '../form-inputs.module.scss';
import { TextFieldProps } from './types';

type Props = TextFieldProps & FieldRenderProps<string, HTMLInputElement>;

const TextField: React.FC<Props> = ({ input, meta, id, bodyQA, ...props }) => {
  const { isDesktop } = useContext(ScreenSizeContext);

  return (
    <div className={styles['field-container']}>
      <Textbox
        {...input}
        {...props}
        defaultValue={input.value ?? undefined}
        errorMessage={getErrorMessage(meta)}
        id={id ?? input.name}
        type={input.type ?? 'text'}
      />
      {bodyQA && isDesktop && meta.active && <QuestionBox {...bodyQA} />}
    </div>
  );
};

export default TextField;
